import { FC } from 'react'
import { Box, Typography, Dialog, SxProps, Theme, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'

const mobileScreenWidth = '767px'

const ModalBody = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    padding: '2.4rem 4rem',
    '&:focus': {
        outline: 'none',
    },
    [`@media (max-width:${mobileScreenWidth})`]: {},
}))

const ModalHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '12%',
    padding: '2.8rem 1.2rem 1.6rem 2.8rem',
    backgroundColor: theme.palette.background.paper,
}))

const CloseIconWrapper = styled(Box)({
    display: 'flex',
    height: '1.3rem',
    marginTop: '-1.3rem',
})

const ModalTitle = styled(Typography)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#3b454d',
})

const ModalFooter = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
}))

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        borderRadius: 10,
        maxWidth: '80rem',
        [`@media (max-width:${mobileScreenWidth})`]: {
            margin: '0.8rem',
            width: 'calc(100% - 1.6rem) !important',
            maxWidth: 'calc(100% - 1.6rem) !important',
        },
    },
})

export interface ModalProps {
    open?: any
    onClose?: any
    title?: any
    footerContent?: any
    headerContent?: any
    disableClose?: boolean
    customDialogClass?: SxProps<Theme>
    children?: React.ReactNode
}

const Modal: FC<ModalProps> = (props) => {
    const {
        open,
        onClose,
        title,
        children,
        headerContent,
        footerContent,
        disableClose,
        customDialogClass,
    } = props

    return (
        <StyledDialog
            scroll={'body'}
            open={open}
            onClose={disableClose ? null : onClose}
            aria-labelledby={title}
            aria-describedby={title}
            sx={customDialogClass}
        >
            <ModalHeader id="dialog-header">
                {!headerContent ? (
                    <ModalTitle>{title}</ModalTitle>
                ) : (
                    headerContent
                )}
                {!disableClose && (
                    <CloseIconWrapper>
                        <IconButton onClick={onClose} size="large">
                            <Icon
                                style={{ height: 13, width: 13 }}
                                name="Close"
                                color="#727272"
                            />
                        </IconButton>
                    </CloseIconWrapper>
                )}
            </ModalHeader>

            {children && <ModalBody id="dialog-body">{children}</ModalBody>}

            {footerContent && (
                <ModalFooter id="dialog-footer">{footerContent}</ModalFooter>
            )}
        </StyledDialog>
    )
}

export default Modal
